import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import type { Article } from '../../../../@types/ArticleV2';
import LazyImage from '../../../../components/lazy/Image';
import Link from '../../../../components/link';
import { useDelayedRender } from '../../../../hooks/renderers';
import { ContentEvents } from '../../../../shared/tracking';
import { IconPlay } from '../../../../styled-components/components/Icon';
import { createArticleUrl } from '../../../articles/utils';

interface ArticleGridCardProps {
  article: Article;
  track: (event: string, data: any) => void;
}

const ArticleGridCard = ({ article, track }: ArticleGridCardProps) => {
  const { t } = useTranslation('startpage');
  const [reference, setReference] = useState<HTMLDivElement | null>(null);

  useDelayedRender(() => {
    track(ContentEvents.NEWS_ITEM_EXPOSURE, {
      newsItemId: article.id,
      newsItemName: article.title,
    });
  }, reference);

  const onClick = () => {
    track(ContentEvents.NEWS_ITEM_VIEW, {
      newsItemId: article.id,
      newsItemName: article.title,
    });
  };

  const src = article.featuredMedia?.file?.url
    ? `url(${article.featuredMedia.file.url}?w=${500}`
    : undefined;
  const url = createArticleUrl(article.categories, article.slug);

  return (
    <div className="overflow-grid-item" ref={setReference}>
      <div className="overflow-grid-content">
        <div data-wx-listcard="thin">
          <LazyImage className="list-card-bg" src={src} />
          <Link
            to={url}
            title={t('Read the article', { ns: 'startpage', name: article.title })}
            onClick={onClick}
            className="list-card"
          >
            <div className="list-card-body no-padding-bottom">
              {(!!article.videoUrl || article.bambuserVideo) && (
                <button type="button" data-wx-actionbutton="action big" title="Spela video">
                  <IconPlay />
                </button>
              )}
            </div>
            <div className="list-card-footer">
              <div className="list-card-heading">
                {article.title.length > 55 ? `${article.title.substring(0, 55)}...` : article.title}
              </div>
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ArticleGridCard;
